import Api from '@/services/Api'

export default {
    cargaFacturas(form){
        return Api().post('cargue/cargaFacturas', form)
    },
    verificaCarga(archivo){
        return Api().post('cargue/verificaCarga/'+archivo)
    },
    cargaFacturasCSV(form){
        return Api().post('cargue/cargaFacturasCSV',form)
    },
}
